<script>
  import { catalog, moreProducts } from '../base/store';
  import ProductsList from '../base/ProductsList.svelte';
  $: products = [
    ...(($catalog.data || {}).products || []),
    //...($moreProducts.products || []),
  ];
</script>

<ProductsList {products} maxCol={3}/>

<!--
{#if !$catalog.loading}
  <ProductsList {products} maxCol={3}/>
{/if}
-->